import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useSession } from '@marriott/mi-headless-utils';
import { EVENT_NAME } from '../../modules/utils/constants/constants';
import { pageViewACDLKeyGenerator } from '../../modules/utils/acdlKeyGenerator';
import { useCurrentUrl } from '../../modules/hooks';
import {
  getRegionEnrollmentSourceCode,
  getLoyaltyEnabledForConferenceZone,
  settlementCurrencyHandler,
  getZonePropertyTier,
} from '../../../src/organisms/InternetBar/utils/handler';
import { EnrollmentSourceCodeDivisionMapping } from '../../../src/organisms/InternetBar/InternetBar.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ACDLAnalyticsWrapper = (pageProps: any) => {
  const { isACDLenabled, datalayer, updateDatalayer } = useSession();
  const url = useCurrentUrl();
  const { preProcessorResponse } = pageProps;
  const internet_box =
    pageProps?.model?.cqItems?.root?.[':items']?.responsivegrid?.[':items']?.hero_banner?.[':items']?.['container-0']?.[
      ':items'
    ]?.internet_box;
  const router = useRouter();
  const urlQueryParams: Record<string, string | string[] | undefined> = router.query;
  const {
    state = '',
    enableLoyalty = false,
    enableLoyaltyPostConnect = false,
    enableLoyaltyConference = false,
    enableLoyaltyConferencePostConnect = false,
    enableLoyaltyForTCTC = false,
    propertyInfo,
    enrollmentSourceCodeMapping,
    weChatEnrollmentSourceCodes = [] as Array<EnrollmentSourceCodeDivisionMapping>,
    userSegment = '' as string,
    locale
  } = preProcessorResponse || {};

  const isLoyaltyEnabledForConference =
    getLoyaltyEnabledForConferenceZone(
      enableLoyaltyConference ? enrollmentSourceCodeMapping?.loyalty : enrollmentSourceCodeMapping?.nonloyalty,
      propertyInfo?.data?.basicInformation?.globalDivision,
      propertyInfo?.data?.contactInformation?.address?.country?.code
    ) ?? false;

  const getUserExperience = (datalayer: Record<string, string | unknown> | undefined) => {
    const { data } = propertyInfo;
    const zoneMappingPricingInfo = {
      GUEST: settlementCurrencyHandler({ ...data }, 'GUEST', internet_box?.internetPricingModel?.currency).pricingInfo,
    };
    const propertyTier = getZonePropertyTier(zoneMappingPricingInfo['GUEST']) ?? 'SF';
    const { dataLists } = internet_box;
    const { enrollmentSourceCode, loyaltyEnrollmentSourceCode } = dataLists;
    let finalEnrollmentSourceCode = '';
    let loyaltyAgeExperience = '';
    if (
      preProcessorResponse?.ageExperienceConfig &&
      preProcessorResponse?.ageExperienceConfig?.userExperience &&
      preProcessorResponse?.ageExperienceConfig?.enrollmentcode
    ) {
      loyaltyAgeExperience = preProcessorResponse?.ageExperienceConfig?.userExperience;
      finalEnrollmentSourceCode = preProcessorResponse?.ageExperienceConfig?.enrollmentcode;
    } else {
      ({ finalEnrollmentSourceCode, loyaltyAgeExperience = '' } = getRegionEnrollmentSourceCode(
        enrollmentSourceCodeMapping,
        data,
        enableLoyalty ||
          enableLoyaltyPostConnect ||
          enableLoyaltyConference ||
          enableLoyaltyConferencePostConnect ||
          isLoyaltyEnabledForConference
          ? enableLoyalty ||
          enableLoyaltyPostConnect ||
          (enableLoyaltyConference && !enableLoyaltyForTCTC) ||
          enableLoyaltyConferencePostConnect ||
          isLoyaltyEnabledForConference
          : urlQueryParams['ppv5Enrollment']?.toString()?.toLowerCase() === 'true',
        propertyTier,
        loyaltyEnrollmentSourceCode ?? '',
        enrollmentSourceCode ?? '',
        state,
        userSegment,
        weChatEnrollmentSourceCodes ?? [],
        (datalayer?.['prop_brand_tier'] as string) ?? '',
        enableLoyaltyForTCTC && (enableLoyalty || (enableLoyaltyConference && isLoyaltyEnabledForConference)),
        urlQueryParams['ppv5Enrollment']?.toString()?.toLowerCase() === 'true' && urlQueryParams?.['LR']?.toString()?.toUpperCase() === 'TCTC',
        locale ?? ''
      ));
    }
    // @todo - To remove finalEnrollmentSourceCode
    // console.log(`FinalEnrollmentSourceCode::`, finalEnrollmentSourceCode);
    return { finalEnrollmentSourceCode, loyaltyAgeExperience };
  };

  useEffect(() => {
    if (datalayer && !!isACDLenabled) {
      /* pageView event pushed at:
         1. Browser load (initial load)
          2. Hash change
            3. Browser history change */
      pushPageViewEvent();
    }
  }, [isACDLenabled, datalayer, url, preProcessorResponse]);

  function pushPageViewEvent() {
    let ageExperience = '';
    let enrollmentSourceCode = '';
    if (preProcessorResponse && preProcessorResponse.propertyInfo) {
      const { loyaltyAgeExperience, finalEnrollmentSourceCode } = getUserExperience(datalayer);
      ageExperience = loyaltyAgeExperience;
      enrollmentSourceCode = finalEnrollmentSourceCode;
    }
    updateDatalayer({
      event: EVENT_NAME.PAGEVIEW,
      ...pageViewACDLKeyGenerator({
        ...datalayer,
        page_portal_age_experience: ageExperience,
        mr_enrollment_source: enrollmentSourceCode,
      }),
    });
  }
  return <></>;
};
